import React, { useState, useEffect } from 'react';
import { PanelLeftClose, PanelLeftOpen, Menu } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const FONT = '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Helvetica Neue", sans-serif';

const ROLE_COLORS = {
  Admin:     '#84CC16',
  Manager:   '#007AFF',
  Warehouse: '#FF9500',
  Sales:     '#AF52DE',
  Finance:   '#34C759',
};

const PAGE_TITLES = {
  dashboard: 'Dashboard',
  inventory: 'Inventory',
  financial: 'Financial',
  tools:     'Tools',
  settings:  'Settings',
  shipping:  'Shipping',
};

const PAGE_SUBTITLES = {
  dashboard: 'Overview of your business',
  inventory: 'Manage stock and products',
  financial: 'Track revenue and expenses',
  tools:     'Calculators and utilities',
  settings:  'App and account settings',
  shipping:  'Track outbound & inbound shipments',
};

export default function Header() {
  const { currentPage, currentUser, sidebarOpen, toggleSidebar, setSidebar } = useApp();
  const roleColor = ROLE_COLORS[currentUser?.role] || '#84CC16';
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <div style={{
      height: 56,
      background: '#ffffff',
      borderBottom: '1px solid rgba(0,0,0,0.07)',
      display: 'flex',
      alignItems: 'center',
      padding: '0 16px',
      gap: 12,
      flexShrink: 0,
      fontFamily: FONT,
    }}>
      <button
        onClick={isMobile ? () => setSidebar(true) : toggleSidebar}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          color: '#8E8E93', padding: '6px', borderRadius: 8,
          display: 'flex', alignItems: 'center', flexShrink: 0,
        }}
        title="Menu"
      >
        {isMobile
          ? <Menu size={20} />
          : sidebarOpen ? <PanelLeftClose size={18} /> : <PanelLeftOpen size={18} />
        }
      </button>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: '#1C1C1E', lineHeight: 1.1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', letterSpacing: '-0.02em' }}>
          {PAGE_TITLES[currentPage] || 'Dashboard'}
        </div>
        {!isMobile && (
          <div style={{ fontSize: 11, color: '#8E8E93', marginTop: 2, fontWeight: 400 }}>
            {PAGE_SUBTITLES[currentPage]}
          </div>
        )}
      </div>

      {currentUser && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
          {!isMobile && (
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#1C1C1E' }}>
                {currentUser.name}
              </div>
              <div style={{ fontSize: 10, color: roleColor, fontWeight: 600, marginTop: 1, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                {currentUser.role}
              </div>
            </div>
          )}
          <div style={{
            width: 32, height: 32,
            borderRadius: 10,
            background: roleColor + '18',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 11, fontWeight: 700, color: roleColor,
          }}>
            {(currentUser.name || '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()}
          </div>
        </div>
      )}
    </div>
  );
}
